import React, { useState } from "react";
import FirstStep from "./FirstStep";

import { AI_FORM_STEPS } from "constants/steps";
import SecondStep from "./SecondStep";

export const ParseAIForm = ({ setIsDialogOpen, setIsDialogClosed }) => {
    const [steps, setSteps] = useState(AI_FORM_STEPS.FIRST);
    return (
        <>
        {   steps === AI_FORM_STEPS.FIRST && (
            <FirstStep 
                setIsDialogOpen={setIsDialogOpen}
                setSteps={setSteps}
            />
        )}
        {
            steps === AI_FORM_STEPS.SECOND && (
                <SecondStep 
                    setIsDialogClosed={setIsDialogClosed}
                    />
            )
        }
        </>
    );
};

export default ParseAIForm;
